exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.first-box[data-v-7bf5e9e2]{\r\n  padding-left: 30px;\r\n  background-color: #f1f1f1;\r\n  height: 50px;\r\n  line-height: 50px;\n}\r\n", ""]);

// exports
